<p-dialog [header]="'ss.prompt.title' | t" [visible]="showPrompt" (onHide)="notNow()" [modal]="true" [draggable]="false"
          [style]="{ width: '440px' }" [breakpoints]="{ '575px': '94vw' }">
  <div class="ssp">
    <p>{{ 'ss.prompt.body' | t }}</p>
    <p class="ssp-tab"><i class="pi pi-window-maximize"></i> {{ 'ss.tabOnly' | t }}</p>
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" [label]="'ss.prompt.later' | t" class="p-button-text p-button-sm" (click)="notNow()"></button>
    <button pButton type="button" icon="pi pi-ticket" [label]="'ss.prompt.ticket' | t" class="p-button-outlined p-button-sm"
            *ngIf="session?.ticketId" (click)="openTicket()"></button>
    <button pButton type="button" icon="pi pi-desktop" [label]="'ss.prompt.open' | t" class="p-button-sm" (click)="openNow()"></button>
  </ng-template>
</p-dialog>

<app-screen-support-room *ngIf="session" [(visible)]="roomOpen" mode="customer" [session]="session" (changed)="refresh()"></app-screen-support-room>
